import { debounce } from "../../utils/debounce.js";
import { isTouchDevice } from "../../utils/isTouch.js";

const DROPDOWN_SELECTOR = ".js-dropdown";
const DROPDOWN_LIST_SELECTOR = ".js-dropdown__list";
const DROPDOWN_ACTIVE_CLASS = "active";

/**
 * Инициализирует дропдаун
 */
export const initDropdown = () => {
    function handleClick(e) {
        const dropdown = e.target.closest(DROPDOWN_SELECTOR);

        // Если кликнули на элемент списка, меню должно оставаться открытым
        if (dropdown && dropdown.classList.contains(DROPDOWN_ACTIVE_CLASS)) {
            const listItem = e.target.closest('.header__languages-switcher-item');
            if (listItem) return; // Если кликнули на элемент списка, ничего не делаем
        }

        // Закрываем все дропдауны, кроме текущего
        closeAllDropdowns(dropdown);

        // Открываем или закрываем текущий дропдаун
        if (dropdown) {
            toggleDropdown(dropdown);
        }
    }

    function handleResize() {
        debounce(() => {
            closeAllDropdowns();
        }, 100)();
    }

    // Обработчики для кликов
    window.addEventListener("click", handleClick);
    if (isTouchDevice()) {
        window.addEventListener("touchstart", handleClick, { passive: false });
    }
    window.addEventListener("resize", handleResize);
};

const closeAllDropdowns = (exclude) => {
    const dropdowns = document.querySelectorAll(DROPDOWN_SELECTOR);
    dropdowns.forEach((el) => {
        if (el === exclude) return;
        closeDropdown(el);
    });
};

/**
 * Открывает/закрывает подменю
 */
const toggleDropdown = (dropdown) => {
    if (dropdown.classList.contains(DROPDOWN_ACTIVE_CLASS)) {
        closeDropdown(dropdown);
    } else {
        openDropdown(dropdown);
    }
};

/**
 * Закрывает подменю
 */
const closeDropdown = (dropdown) => {
    const dropdownList = dropdown.querySelector(`:scope > ${DROPDOWN_LIST_SELECTOR}`);

    dropdown?.classList.remove(DROPDOWN_ACTIVE_CLASS);
    dropdownList?.classList.remove(DROPDOWN_ACTIVE_CLASS);
};

/**
 * Открывает подменю
 */
const openDropdown = (dropdown) => {
    const dropdownList = dropdown.querySelector(`:scope > ${DROPDOWN_LIST_SELECTOR}`);

    dropdown?.classList.add(DROPDOWN_ACTIVE_CLASS);
    dropdownList?.classList.add(DROPDOWN_ACTIVE_CLASS);
};
